import './CompanyDialog.css';
import React, { useEffect } from 'react';
import { withTranslate } from 'react-redux-multilingual';
import PasswordStrengthBar from 'react-password-strength-bar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';


function CompanyDialog(props) {
    const { translate, open, data, handleClose, handleAgree } = props;
    const [isError, setIsError] = React.useState(false);
    const [companyID, setCompanyID] = React.useState();
    const [companyName, setCompanyName] = React.useState();
    const [telNumber, setTelNumber] = React.useState();
    const [endDate, setEndDate] = React.useState();
    const [remarks, setRemarks] = React.useState();

    const handleClickAgree = () => {
        setIsError(false);
        if(
            !companyName ||
            !telNumber
        ) {
            setIsError(true);
            return;
        }
        handleAgree({
            companyID
            ,companyName
            ,telNumber
            ,endDate
            ,remarks
        });
    }

    useEffect(() => {
        setIsError(false);
        setCompanyID(data?.companyID);
        setCompanyName(data?.companyName);
        setTelNumber(data?.telNumber);
        setEndDate(data?.endDate || null);
        setRemarks(data?.remarks);
    }, [open])

    return (
    <div>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>
          {data?.userID ? translate('editcompany') : translate('addnewcompany')}
        </DialogTitle>
        <DialogContent dividers>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormControl fullWidth required className='company-dialog'>
                        <Typography fontSize="inherit" component="label">{translate('companyname')}</Typography>
                        <OutlinedInput
                            id="companyName"
                            size='small' 
                            placeholder=""
                            value={companyName}
                            error={(!companyName) && isError}
                            onChange={(e) => {
                                setCompanyName(e.target.value);
                            }}
                        />
                        {(!telNumber) && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth required className='company-dialog'>
                        <Typography fontSize="inherit" component="label">{translate('telnumber')}</Typography>
                        <OutlinedInput
                            id="telNumber"
                            size='small' 
                            placeholder=""
                            value={telNumber}
                            error={(!telNumber) && isError}
                            onChange={(e) => {
                                setTelNumber(e.target.value);
                            }}
                        />
                        {(!telNumber) && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                {companyID &&
                <Grid item xs={6}>
                     <FormControl fullWidth required className='users-dialog'>
                         <Typography fontSize="inherit" component="label">{translate('expiration')}</Typography>
                         <OutlinedInput
                            id="endDate"
                            size='small'
                            type='date'
                            placeholder=""
                            value={endDate}
                            error={!endDate && isError}
                            onChange={(e) => setEndDate(e.target.value || null)}
                         />
                         {!endDate && isError &&
                             <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                         }
                     </FormControl>
                 </Grid>
                }
                <Grid item xs={12}>
                    <FormControl fullWidth required className='company-dialog'>
                        <Typography fontSize="inherit" component="label">{translate('remarks')}</Typography>
                        <OutlinedInput
                            id="remarks"
                            size='small'
                            type='text'
                            multiline
                            maxRows={4}
                            placeholder=""
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                        />
                     </FormControl>
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button variant="contained" size="small" disableElevation color='secondary' onClick={handleClose}>
            {translate('cancel')}
            </Button>
            <Button variant="contained" size="small" disableElevation color="info" onClick={handleClickAgree}>
            {translate('ok')}
            </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default withTranslate(CompanyDialog);